module.exports = __webpack_public_path__ + "img/edai-logo.232e2b4c.svg";